/** Скелет корня клиентского embed при ожидании публичного конфига / витрины. */
export function ClientIndexSkeleton() {
  return (
    <div className="w-full min-w-0 space-y-4 px-1" aria-busy="true">
      <div className="h-8 w-48 animate-pulse rounded-lg bg-[var(--bg-soft)]" />
      <div className="h-4 w-full max-w-md animate-pulse rounded bg-[var(--bg-soft)]" />
      <div className="h-32 animate-pulse rounded-2xl bg-[var(--bg-soft)]" />
    </div>
  );
}
